import { useDispatch, useSelector } from 'react-redux';
import { addCategory, updateCategory, incrementNextTempId } from '../actions';

export const useCategoryHandlers = ({ setShowMenuModal, setShowSubModal, setEditMode, setItemToEdit }) => {
  const buttons = useSelector(state => state.buttons);
  const nextTempId = useSelector(state => state.nextTempId);
  const dispatch = useDispatch();

  const categories = buttons.filter(b => b.parent_id === null);

  const handleSaveNewCategory = (data) => {
    const sortedCategories = [...categories].sort((a, b) => (a.order_number ?? 0) - (b.order_number ?? 0));

    const updatedCategories = [...sortedCategories];

    // Shift last two categories by +1
    for (let i = updatedCategories.length - 2; i < updatedCategories.length; i++) {
      updatedCategories[i] = {
        ...updatedCategories[i],
        order_number: updatedCategories[i].order_number + 1,
      };
    }

    dispatch(addCategory({
      id: 'temp_' + nextTempId,
      name: data.name,
      icon: data.icon,
      uploaded_icon: data.uploaded_icon,
      link: data.link,
      link_file: data.file,
      order_number: sortedCategories.length - 1,
      parent_id: null,
      checked: true,
      default: false,
      system_field: false,
    }));
    updatedCategories.slice(-2).forEach(cat => {
      dispatch(updateCategory(cat));
    });
    dispatch(incrementNextTempId());
    setShowMenuModal(false);
    window.glg.is_dirty = true;
  };

  const handleSaveNewSubcategory = (data) => {
    dispatch(addCategory({
      id: 'temp_' + nextTempId,
      name: data.name,
      icon: null,
      link: data.link,
      link_file: data.file,
      order_number: buttons.filter(b => b.parent_id === data.parent_id).length + 1,
      parent_id: data.parent_id,
      checked: true,
      default: false,
      system_field: false,
    }));
    dispatch(incrementNextTempId());
    setShowSubModal(false);
    window.glg.is_dirty = true;
  };

  const handleUpdateCategory = (data) => {
    dispatch(updateCategory({
      ...data,
      name: data.name,
      icon: data.icon,
      uploaded_icon: data.uploaded_icon,
      link: data.link,
      link_file: data.file,
    }));
    setShowMenuModal(false);
    setEditMode(false);
    setItemToEdit(null);
    window.glg.is_dirty = true;
  };

  const handleUpdateSubcategory = (data) => {
    dispatch(updateCategory({
      ...data,
      name: data.name,
      link: data.addType === 'link' ? data.link : null,
      link_file: data.addType === 'upload' ? data.file : null,
      parent_id: data.parent_id,
    }));
    setShowSubModal(false);
    setEditMode(false);
    setItemToEdit(null);
    window.glg.is_dirty = true;
  };

  return {
    handleSaveNewCategory,
    handleSaveNewSubcategory,
    handleUpdateCategory,
    handleUpdateSubcategory,
  };
};
